<template>
    <FormSection title="Documents" :full-height="false" :application-id="referral.application">
        <template #content>
            <section class="row px-4 py-2">
                <div class="w-100 referral-documents-wrapper">
                    <PatientDocuments
                        :patient-id="referral.id"
                        :application="referral.application"
                        :provider-id="providerId"
                        :account-id="referral.accountId"
                        :upload-document="uploadDocument"
                        :delete-document="deleteDocument"
                        :get-documents="getReferralDocuments"
                        :is-palliative="isPalliative"
                        :is-referral-page="true"
                        :referral="referral"
                    />
                </div>
            </section>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./ReferralDocuments.ts" />
<style lang="scss" src="./ReferralDocuments.scss"></style>
